<template>
  <b-nav-item-dropdown
    left
    v-if="
      paymentOptionsHaveNoTransactionsResponse.length > 0 ||
      numberOfFaiedTransctionsToNotifyMerchant > 100 ||
      totalRefundRequests > 0 ||
      totalMismatches
    "
  >
    <template #button-content>
      <b-avatar
        size="40"
        variant="danger"
        :badge="String(isImportant)"
        class="badge-minimal"
        badge-variant="dark"
      >
        <feather-icon variant="primary" icon="BellIcon" size="22" />
      </b-avatar>
    </template>

    <!-- Header -->
    <div>
      <div
        class="dropdown-header d-flex"
        v-if="
          $can('GetErrorNotification', 'Report') &&
          numberOfFaiedTransctionsToNotifyMerchant > 100
        "
      >
        <b-media>
          <template #aside>
            <b-avatar size="32" variant="danger">
              <feather-icon icon="ListIcon" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <b-button
              id="tooltip-target-1"
              variant="light"
              :to="{ name: 'ExceptionReport-View' }"
            >
              You have &nbsp;
              <strong> {{ numberOfFaiedTransctionsToNotifyMerchant }} </strong>
              &nbsp; Exception Transactions !
            </b-button>
          </p>
        </b-media>
      </div>

      <div
        class="dropdown-header d-flex"
        v-if="
          totalRefundRequests > 0 && $can('GetFailedRefundRequests', 'Report')
        "
      >
        <b-media>
          <template #aside>
            <b-avatar size="32" variant="light-warning">
              <feather-icon icon="ListIcon" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <b-button
              id="tooltip-target-1"
              variant="light"
              :to="{ name: 'ExceptionReport-View' }"
            >
              <strong> {{ totalRefundRequests }} </strong> &nbsp; Refund
              Exception Transactions !
            </b-button>
          </p>
        </b-media>
      </div>

      <div
        class="dropdown-header d-flex"
        v-if="
          paymentOptionsHaveNoTransactionsResponse.length > 0 &&
          $can('GetNotificationAlertToTrackingPayment', 'Report')
        "
      >
        <b-media>
          <template #aside>
            <b-avatar size="32" variant="light-warning">
              <feather-icon icon="ListIcon" />
            </b-avatar>
          </template>
          <p class="notification-title mb-0 mr-auto"></p>
          <b-button
            id="tooltip-target-1"
            variant="light"
            v-b-modal.modal-paymentOptionsHaveNoTransactionsResponse
          >
            {{ paymentOptionsHaveNoTransactionsResponse.length }} Paid FOPs Need
            Attention
          </b-button>
        </b-media>
      </div>

      <div
        class="dropdown-header d-flex"
        v-if="
          $can('GetWeeklyMismatchSummaryAlert', 'Report') && totalMismatches > 0
        "
      >
        <b-media>
          <template #aside>
            <b-avatar size="32" variant="light-warning">
              <feather-icon icon="ListIcon" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <b-button
              id="tooltip-target-1"
              variant="light"
              :to="{ name: 'Reconciliations-UnmatchedSummaryReport' }"
            >
              There are
              <strong> {{ totalMismatches }} </strong> outstanding unmatched
              transactions from last week.
            </b-button>
          </p>
        </b-media>
      </div>

      <div
        class="dropdown-header d-flex"
        v-if="
          getStatementAvailablityAlert.totalSummary.totalCount > 0 &&
          $can('GetStatementAvailablityAlert', 'Report')
        "
      >
        <b-media>
          <template #aside>
            <b-avatar size="32" variant="light-warning">
              <feather-icon icon="ListIcon" />
            </b-avatar>
          </template>
          <p class="notification-title mb-0 mr-auto"></p>
          <b-button
            id="tooltip-target-1"
            variant="light"
            v-b-modal.modal-getStatementAvailablityAlert
          >
            {{ getStatementAvailablityAlert.totalSummary.totalCount }} providers
            have no BS data
          </b-button>
        </b-media>
      </div>
    </div>

    <b-modal id="modal-paymentOptionsHaveNoTransactionsResponse" ok-only>
      There are no transactions processed with these forms of payment: &nbsp;
      <span
        v-for="item in paymentOptionsHaveNoTransactionsResponse"
        :key="item"
        class="font-weight-bolder"
      >
        {{ item }},&nbsp;
      </span>
      in the last 24 hours.
    </b-modal>

    <b-modal id="modal-getStatementAvailablityAlert" ok-only>
      No transactions were recorded on the bank statements for the following
      banks: <br />
      <span
        v-for="item in getStatementAvailablityAlert.alertDetail"
        :key="item.provider"
        class="font-weight-bolder"
      >
        {{ item.provider }}, </span
      ><br />
      for the previous day, {{ getStatementAvailablityAlert.dateRange }}
    </b-modal>

    <!-- Notifications -->
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BModal,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { avatarText } from "@core/utils/filter";
import axios from "@axios";
export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BModal,
  },
  data() {
    return {
      numberOfFaiedTransctionsToNotifyMerchant: null,
      paymentOptionsHaveNoTransactionsResponse: [],
      totalRefundRequests: null,
      totalMismatches: null,
      getStatementAvailablityAlert: {
        alertDetail: [],
        totalSummary: {
          totalCount: 0,
        },
        dateRange: "",
      },
      avatarText,
    };
  },
  computed: {
    isImportant() {
      if (
        this.paymentOptionsHaveNoTransactionsResponse.length > 0 ||
        this.numberOfFaiedTransctionsToNotifyMerchant > 100 ||
        this.totalRefundRequests > 0 ||
        this.totalMismatches ||
        this.getStatementAvailablityAlert.totalSummary.totalCount > 0
      ) {
        return 1;
      } else {
        return 0;
      }
    },
  },
  created() {
    this.getErrorNotification();
    this.getNotificationAlertToTrackingPayment();
    this.GetFailedRefundRequests();
    this.GetWeeklyMismatchSummaryAlert();
    this.GetStatementAvailablityAlert();
  },
  methods: {
    getErrorNotification() {
      let currentdefaultMerchant = localStorage.getItem("defaultMerchantId");
      currentdefaultMerchant = JSON.parse(currentdefaultMerchant);

      axios
        .get(
          `/Order/api/V1.0/Report/GetErrorNotification?MerchantId=${currentdefaultMerchant}`,
        )
        .then((res) => {
          this.numberOfFaiedTransctionsToNotifyMerchant =
            res.numberOfNotificaionResponse.numberOfFaiedTransctionsToNotifyMerchant;
        })
        .catch((err) => {});
    },
    getNotificationAlertToTrackingPayment() {
      axios
        .get(`/Order/api/V1.0/Report/GetNotificationAlertToTrackingPayment`)
        .then((res) => {
          this.paymentOptionsHaveNoTransactionsResponse =
            res.paymentOptionsHaveNoTransactionsResponse;
        })

        .catch((err) => {});
    },
    GetFailedRefundRequests() {
      axios
        .get(`/Order/api/V1.0/Refund/GetFailedRefundRequests`)
        .then((res) => {
          this.totalRefundRequests = res.totalRefundRequests;
        })

        .catch((err) => {});
    },

    GetWeeklyMismatchSummaryAlert() {
      axios
        .get(
          `/Reconciliation/api/V1.0/Reconciliation/GetWeeklyMismatchSummaryAlert`,
        )
        .then((res) => {
          this.totalMismatches = res.totalMismatches;
        })

        .catch((err) => {});
    },
    GetStatementAvailablityAlert() {
      axios
        .get(
          `/BankStatements/api/V1.0/BankStatements/GetStatementAvailablityAlert`,
        )
        .then((res) => {
          this.getStatementAvailablityAlert = res;
          // res.dateRange
          // res.totalSummary.totalCount
        })

        .catch((err) => {});
    },
  },
};
</script>
